import React, { useEffect, useState } from "react";
import { renderRichText } from "@storyblok/react";
import { useNavigate } from "react-router-dom";
import { ProductKeyFeatureModel } from "../../ShowcasePanel/ShowcasePanelModel";
import { FeatureGridPanelModel } from "../FeatureGridPanelModel";
import Utils from "../../../core/Utils/Utils";
import { Theme } from "../../../core/Models/CustomSiteConfigModel";
import { themeService } from "../../../core/NotificationStripNav/ThemeService";

import "./FeatureGridPanelItem.css";

const FeatureGridPanelItem: React.FC<{
  blok: ProductKeyFeatureModel;
  fgp: FeatureGridPanelModel;
}> = ({ blok, fgp }) => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());
  const navigate = useNavigate();
  const defaultBorderColor = "#555555";
  const [borderColor, setBorderColor] = useState(defaultBorderColor);
  const [showOverlay, setShowOverlay] = useState(false);

  const descriptionHTML = renderRichText(blok.description) || "";
  const secondaryDescriptionHTML =
    renderRichText(blok.secondaryDescription) || "";

  const handleContainerClick = (e: React.MouseEvent) => {
    if (window.innerWidth > 480) {
      e.preventDefault();
      e.stopPropagation();

      if (blok.hyperlink?.cached_url) {
        if (blok.hyperlink?.linktype === "story") {
          navigate(`/${blok.hyperlink.cached_url}`);
        } else {
          const url = new URL(
            blok.hyperlink.cached_url,
            window.location.origin
          );
          window.location.href = url.href;
        }
      }
    } else {
      setShowOverlay(!showOverlay);
    }
  };

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (blok.hyperlink?.cached_url) {
      if (blok.hyperlink?.linktype === "story") {
        navigate(`/${blok.hyperlink.cached_url}`);
      } else {
        const url = new URL(blok.hyperlink.cached_url, window.location.origin);
        window.location.href = url.href;
      }
    }
  };
  const url = blok.hyperlink?.cached_url
    ? `/${blok.hyperlink.cached_url}`
    : undefined;

  useEffect(() => {
    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  return (
    <div
      className={`feature-grid-panel-item ${showOverlay ? "show-overlay" : ""}`}
      onMouseEnter={() => {
        setBorderColor(fgp.hoverBorderColor);
        setShowOverlay(true);
      }}
      onMouseLeave={() => {
        setBorderColor(defaultBorderColor);
        setShowOverlay(false);
      }}
      style={{ borderColor: borderColor }}
      onClick={handleContainerClick}
    >
      {blok.image?.filename && (
        <img
          src={Utils.getCacheUrl(blok.image?.filename)}
          alt=""
          onError={(e) => Utils.handleImageError(e, blok.image.filename)}
        />
      )}
      <div className="feature-grid-overlay"></div>
      <div className="feature-grid-panel-item-container">
        <div className="title">{blok.title}</div>
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: descriptionHTML }}
        ></div>
        <div
          className="second-description"
          dangerouslySetInnerHTML={{ __html: secondaryDescriptionHTML }}
        ></div>
        {url && (
          <div className="hyperlink-container">
            <a
              onClick={handleClick}
              href={url}
              className="hyperlink"
              style={{ color: fgp.hyperlinkColor || theme?.hyperlinksColor }}
            >
              {blok.hyperlinkLabel ? blok.hyperlinkLabel : "See pricing"}
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeatureGridPanelItem;
